<template>
  <v-card-title flat :class="{ 'blue-grey darken-4': dark }" class="px-2 py-2">
    <v-icon :dark="dark" class="mr-3" v-text="icon"></v-icon>
    <div>
      <a v-if="clickable" class="body-1" @click="$emit('click')">
        {{ title }}
      </a>
      <div v-else :class="{ 'white--text': dark }" class="body-1">
        {{ title }}
      </div>
      <div class="caption grey--text" v-text="subtitle"></div>
    </div>
    <v-spacer></v-spacer>
    <v-btn v-if="closable" icon small @click="$emit('close')">
      <v-icon
        small
        :class="dark ? 'white--text' : ''"
        v-text="$getIcon('mdiClose')"
      >
      </v-icon>
    </v-btn>
    <slot name="actions"></slot>
  </v-card-title>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>
